import { CountryCode } from '@domains/country';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const COMMON_QA_AGENTS = [
  'lauracanon@habi.co',
  'carlosbaquero@habi.co',
  'cristianpalacios@tuhabi.mx',
  'edwardmartinez@habi.co',
  'santiagosalcedo@habi.co',
] as const;

export const AGENTS = {
  CO: {
    QA: COMMON_QA_AGENTS,
    PROD: [
      'aprobologo1@habi.co',
      'aprobologo2@habi.co',
      'aprobologo3@habi.co',
      'aprobologo4@habi.co',
      'geraldinecastrillo@habi.co',
    ],
  },
  MX: {
    QA: COMMON_QA_AGENTS,
    PROD: [
      'aprobologo1@tuhabi.mx',
      'aprobologo2@tuhabi.mx',
      'aprobologo3@tuhabi.mx',
      'aprobologo4@tuhabi.mx',
      'geraldinecastrillo@habi.co',
    ],
  },
} as const;

const normalizeEnv = (): 'QA' | 'PROD' => {
  const rawEnv = process.env.ENV_ORIGIN ?? '';
  const env = rawEnv.trim().toLowerCase();
  return env === 'qa' ? 'QA' : 'PROD';
};

export const getAgentsByEnv = (country?: CountryCode): readonly string[] => {
  if (!country || !AGENTS.hasOwnProperty(country)) {
    console.warn(`País no definido o no soportado: ${country}`);
    return [];
  }

  const env = normalizeEnv();
  return AGENTS[country][env];
};

export const useHandleReassignTasks = (
  isError: boolean,
  isSuccess: boolean,
  setShowModal: (value: boolean) => void,
  clearState?: () => void
) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (isError) {
      toast.error('Error al reasignar esta tarea', {
        toastId: 'errorAssignTask',
      });
      clearState?.();
    }
  }, [isError]);

  useEffect(() => {
    if (isSuccess) {
      toast.success('Tarea(s) asignada(s) correctamente', {
        toastId: 'successDocumentTask',
      });
      clearState?.();
      setShowModal(false);
      navigate('/document-audit/reassign-tasks');
    }
  }, [isSuccess]);
};
